import { z } from 'zod';

const KEY = 'first-table-map-selected-restaurant-id';

const selectedRestaurantIdSchema = z.number().min(0);

type SelectedRestaurantId = z.infer<typeof selectedRestaurantIdSchema>;

export function getSessionSelectedRestaurantId() {
  const sessionValue = sessionStorage.getItem(KEY);

  if (!sessionValue) {
    return;
  }

  const { success, data } = selectedRestaurantIdSchema.safeParse(JSON.parse(sessionValue));

  if (success) {
    return data;
  }
}

export function setSessionSelectedRestaurantId(viewState: SelectedRestaurantId) {
  sessionStorage.setItem(KEY, JSON.stringify(viewState));
}

export function removeSessionSelectedRestaurantId() {
  sessionStorage.removeItem(KEY);
}
